import { baseApi, ENDPOINTS } from '@/shared/api';

import type { TablePreference } from './types';

const tableColumnsApi = baseApi
    .enhanceEndpoints({
        addTagTypes: ['TableColumns'],
    })
    .injectEndpoints({
        endpoints: (build) => ({
            getTableColumns: build.query<TablePreference, string>({
                query: (tableId) =>
                    ENDPOINTS.tableColumns.getTableColumns(tableId),
                transformResponse: (response: unknown, _meta, arg: string) => {
                    if (
                        response &&
                        typeof response === 'object' &&
                        'json' in response
                    ) {
                        return response as TablePreference;
                    }

                    return {
                        id: 0,
                        table_name: arg,
                        json: {
                            columns: {},
                        },
                    };
                },
                providesTags: (_result, _error, tableId) => [
                    { type: 'TableColumns', id: tableId },
                ],
            }),
            updateTableColumns: build.mutation<
                void,
                {
                    tableId: string;
                    columns: Record<
                        string,
                        { visible: boolean; order: number }
                    >;
                }
            >({
                query: ({ tableId, columns }) => ({
                    url: ENDPOINTS.tableColumns.updateTableColumns(tableId),
                    method: 'PUT',
                    body: {
                        json_field: {
                            columns: Object.entries(columns).reduce(
                                (acc, [key, value]) => ({
                                    ...acc,
                                    [key]: {
                                        key,
                                        ...value,
                                    },
                                }),
                                {},
                            ),
                        },
                    },
                }),
                invalidatesTags: (_result, _error, { tableId }) => [
                    { type: 'TableColumns', id: tableId },
                ],
            }),
        }),
    });

export const { useGetTableColumnsQuery, useUpdateTableColumnsMutation } =
    tableColumnsApi;
